module.exports = __webpack_public_path__ + "static/media/edit.6dc7cb85.svg";